/* eslint-disable max-len */
<template>
  <v-layout column class="hide-overflow b-r" style="height:100%">
    <div v-if="admin" class="toolbar b-b">
      <v-row style="align-items: center" dense class="ma-0 mr-2 ml-2">
        <v-col cols="12" md="5"><PositionCount admin /></v-col>
        <v-col cols="12" md="4" class="pr-4">
          <v-select
            no-gutter
            v-model="activeCategories"
            :items="items"
            prepend-icon="mdi-filter"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <PositionNew @jobCreated="refresh" />
        </v-col>
      </v-row>
    </div>
    <PositionCount
      :admin="admin"
      v-if="!admin"
      class="b-b"
      style="background: white"
    />

    <ReportDialog
      :jobId="selectedJobID"
      :dialog="dialog"
      @closed="dialog = false"
    />

    <v-dialog
      width="400"
      v-model="exitDialog"
    >
      <v-card>
        <v-card-title class="b-b">
          Navigating to an external job site
        </v-card-title>
        <v-card-text class="black--text">
          <p class="mt-3">Thank you for considering this position.</p>
          <p>
            Please note that to continue with the search, you will be directed to an
            external job site. Before applying, we recommend that you carefully review
            the job description to ensure that your qualifications, skills, and experience
            align with the position requirements.</p>
          <p>
            We kindly ask that you refrain from submitting multiple applications for job openings that
            do not match your qualifications and skills.
          </p>
          <p>
            More information about working in Finland can be found from:
            <a href="https://www.workinfinland.com/en/get-started/">https://www.workinfinland.com/en/get-started/</a>
          </p>
        </v-card-text>
        <v-card-actions class="b-t">
          <v-spacer></v-spacer>
          <v-btn text @click="exitDialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="exitDialog=false" :href="exitUrl" target="_blank">Agree and continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DynamicScroller
      :items="matchPositions"
      :min-item-size="154"
      class="dynamic-scroller pt-2 pb-2"
      :buffer="400"
    >
      <template v-slot="{ item, index, active }">
        <DynamicScrollerItem
          :item="item"
          :active="active"
          :size-dependencies="[
            item.title,
            item.employer.name,
            item.location.city,
            item.location.area,
          ]"
          :data-index="index"
        >
          <!-- Result card -->
          <div>
            <v-card
              outlined
              class="pa-3 ml-2 mr-2"
              elevation="0"
              :key="item.id"
              :class="[
                'position-row',
                selectedPositionId === item.id ? 'active-row' : '',
                item.match ? 'match-row' : '',
                item.featured ? 'featured' : ''
              ]"
            >
              <v-row no-gutters dense class="b-b pb-2" style="cursor:pointer" @click="admin ? activateNode(item) : openUrl(item)">
                <v-col cols="10">
                  <div class="position-title mt-0 align-center d-flex">
                    {{ item.title }}
                    <v-tooltip top max-width="200" color="primary" v-if="item.status && item.status.transformations && item.status.transformations.machineTranslated">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Job title has been machine translated. You can let us know of inaccurate translations through the report button.</span>
                    </v-tooltip>
                  </div>
                  <p class="position-subtitle">{{ item.employer.name }}</p>
                  <div class="position-tag-wrapper">
                    <span
                      v-for="category of item.clustering.categories"
                      :key="category.name"
                      v-bind:class="[
                        'position-tag',
                        category.name.toLowerCase(),
                      ]"
                    >
                      {{ category.name.toLowerCase() }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="2">
                  <div
                    v-if="item.imageUrl"
                    class="position-logo"
                    v-bind:style="{
                      'background-image': 'url(' + item.imageUrl + ')',
                      width: '100%',
                      height: '40px',
                      'background-position': 'top right',
                    }"
                  ></div>
                  <div
                    v-if="
                      admin &&
                      item.status &&
                      item.status.reviewStatus == 'human'
                    "
                    class="primary"
                    style="
                      right: 4px;
                      top: 4px;
                      border-radius: 100%;
                      padding: 0.2rem;
                      display: block;
                      position: absolute;
                      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                    "
                  >
                    <v-icon style="color: white">mdi-check</v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row dense no-gutters class="mt-2 align-center">
                <v-col>
                  <p class="position-subtitle">
                    {{ item.location.city ? item.location.city : "Unknown" }}, {{ item.location.area }}
                  </p>
                </v-col>
                <v-col class="text-right" v-if="admin">
                  <v-tooltip
                    right
                    v-if="
                      item.status &&
                      Object.keys(item.status.reportedBecause).length > 0
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        small
                        class="ma-1 only-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small> mdi-alert-octagon </v-icon>
                      </v-chip>
                    </template>
                    <span>Reported</span>
                  </v-tooltip>
                  <v-tooltip
                    right
                    v-if="
                      item.status &&
                      Object.keys(item.status.hiddenBecause).length > 0
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        small
                        class="ma-1 only-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-eye-off</v-icon>
                      </v-chip>
                    </template>
                    <span>Hidden ( {{Object.keys(item.status.hiddenBecause).join(', ')}} )</span>
                  </v-tooltip>
                </v-col>
                <v-col class="text-right" v-else>
                  <v-icon class="position-open mr-2" @click="openUrl(item)">
                    mdi-open-in-new
                  </v-icon>
                  <v-icon
                    class="mr-2"
                    color="primary"
                    v-if="!checkFavorite(item.id)"
                    @click="saveFavorite(item.id)"
                    >mdi-star-outline</v-icon
                  >
                  <v-icon
                    class="mr-2"
                    color="primary"
                    @click="saveFavorite(item.id)"
                    v-else
                    >mdi-star</v-icon
                  >
                  <v-icon
                    color="primary"
                    @click="
                      selectedJobID = item.id;
                      dialog = true;
                    "
                    >mdi-dots-horizontal</v-icon
                  >
                </v-col>
              </v-row>
            </v-card>
            <div style="height: 8px"></div>
          </div>
        </DynamicScrollerItem>
      </template>
    </DynamicScroller>

    <!-- <v-flex
      ref="dataTable"
      class="data-table d-none d-sm-block"
      v-if="matchPositions.length > 0"
    >

      <v-data-table
        :headers="computedHeaders"
        :items="matchPositions"
        :sort-by="['sortKey']"
        :sort-desc="['true']"
        class="elevation-0"
        :footer-props="{
          itemsPerPageOptions: [20, 50, 100],
        }"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-on:click="activateNode(item)"
              v-for="item in items"
              :class="[
                'position-row',
                selectedPositionId === item.id ? 'active-row' : '',
                item.match ? 'match-row' : '',
              ]"
              :key="item.id"
              :id="item.id"
            >
              <td
                style="
                  position: relative;
                  width: 130px;
                  padding: 6px;
                  align-items: center;
                "
              >
                <div
                  v-if="
                    admin && item.status && item.status.reviewStatus == 'human'
                  "
                  class="primary"
                  style="
                    left: 4px;
                    top: 4px;
                    border-radius: 100%;
                    padding: 0.2rem;
                    display: block;
                    position: absolute;
                    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                  "
                >
                  <v-icon style="color: white">mdi-check</v-icon>
                </div>
                <div class="d-flex align-center justify-center">
                  <div
                    v-if="item.imageUrl"
                    class="position-logo"
                    v-bind:style="{
                      'background-image': 'url(' + item.imageUrl + ')',
                    }"
                  ></div>
                  <div v-else class="position-logo">
                    {{ item.employer.name }}
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <p class="position-title">{{ item.title }}</p>
                  <p class="position-subtitle">{{ item.employer.name }}</p>
                  <div class="position-tag-wrapper">
                    <span
                      v-for="category of item.clustering.categories"
                      :key="category.name"
                      v-bind:class="[
                        'position-tag',
                        category.name.toLowerCase(),
                      ]"
                    >
                      {{ category.name.toLowerCase() }}
                    </span>
                  </div>
                </div>
              </td>
              <td style="width: 130px">
                <p class="position-title">{{ item.location.city }}</p>
                <p class="position-subtitle">{{ item.location.area }}</p>
              </td>
              <td style="width: 130px" v-if="!admin">
                <v-row no-gutters class="align-center">
                  <v-col dense>
                    <v-icon
                      class="position-open"
                      @click="openUrl(item)"
                    >
                      mdi-open-in-new
                    </v-icon>
                  </v-col>
                  <v-col dense>
                    <v-icon
                      color="primary"
                      v-if="!checkFavorite(item.id)"
                      @click="saveFavorite(item.id)"
                      >mdi-star-outline</v-icon
                    >
                    <v-icon
                      color="primary"
                      @click="saveFavorite(item.id)"
                      v-else
                      >mdi-star</v-icon
                    >
                  </v-col>
                  <v-col dense>
                    <v-icon
                      color="primary"
                      @click="
                        selectedJobID = item.id;
                        dialog = true;
                      "
                      >mdi-dots-horizontal</v-icon
                    >
                  </v-col>
                </v-row>
              </td>
              <td v-if="admin" width="50px">
                <v-tooltip
                  right
                  v-if="
                    item.status &&
                    Object.keys(item.status.reportedBecause).length > 0
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      small
                      class="ma-1 only-icon"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small> mdi-alert-octagon </v-icon>
                    </v-chip>
                  </template>
                  <span>Reported</span>
                </v-tooltip>
                <v-tooltip
                  right
                  v-if="
                    item.status &&
                    Object.keys(item.status.hiddenBecause).length > 0
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      small
                      class="ma-1 only-icon"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>mdi-eye-off</v-icon>
                    </v-chip>
                  </template>
                  <span>Hidden</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex> -->
  </v-layout>
</template>
<script>
import ReportButton from '@/components/ReportButton.vue';
import PositionCount from '@/components/PositionCount.vue';
import PositionNew from '@/components/PositionNew.vue';
import ReportDialog from '@/components/ReportDialog.vue';
import AnalyticsService from '@/services/analytics.service.js';

export default {
  name: 'positionList',
  components: {
    ReportButton,
    PositionCount,
    PositionNew,
    ReportDialog,
  },
  props: {
    graph: {
      type: Array,
      required: true,
    },
    admin: {
      type: Boolean,
      required: false,
    },
    featuredJobs: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      listSelectID: null,
      showOnlyUnreviewed: false,
      options: {
        itemsPerPage: 50,
      },
      dialog: false,
      exitDialog: false,
      exitUrl: null,
      selectedJobID: null,
      dialogData: {
        organization: '',
        dataOrigin: '',
        description: '',
        firstSeen: '',
        lastSeen: '',
        id: '',
        languages: [],
        location: {
          area: '',
          city: '',
          country: '',
        },
        content: '',
        originalId: '',
        title: '',
        url: '',
      },
      headers: [
        {
          text: 'Company',
          value: 'employer.name',
          class: 'custom-data-table-header',
        },
        {
          text: 'Open position',
          value: 'title',
          class: 'custom-data-table-header',
        },
        {
          text: 'Location',
          value: 'location.city',
          class: 'custom-data-table-header',
        },
        {
          text: 'Status',
          value: 'status',
          class: 'custom-data-table-header',
        },
      ],
      activeCategories: 'All',
      items: ['All', 'User submitted', 'Unreviewed', 'Machine translated', 'Automatically hidden', 'Reviewed', 'Hidden'],
    };
  },
  created() {
    this.unsubscribe = this.$store.subscribeAction((action, state) => {
      if (action.type === 'commitSelectedPosition') {
        // TODO: Scroll into view
        console.log('Selected position: ' + action.payload.id);
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    matchPositions() {
      if (this.activeCategories === 'Unreviewed') {
        return this.graph.filter(
          (position) =>
            position.match && !(position.status && position.status.reviewStatus !== 'unreviewed')
        );
      } else if (this.activeCategories === 'Reviewed') {
        return this.graph.filter(
          (position) =>
            position.match && position.status && position.status.reviewStatus !== 'unreviewed'
        );
      } else if (this.activeCategories === 'User submitted') {
        // Filter user submitted jobs
        return this.graph.filter(
          (position) =>
            position.match && (
              position.source.apiId.includes('jobsinfinland.fi')
            )
        );
      } else if (this.activeCategories === 'Machine translated') {
        // Filter machine translated jobs
        return this.graph.filter(
          (position) =>
            position.match && position.status.transformations && (
              position.status.transformations.machineTranslated
            )
        );
      } else if (this.activeCategories === 'Automatically hidden') {
        // Filter jobs hidden in the fetcher process
        return this.graph.filter(
          (position) =>
            position.match && position.status.transformations && (
              position.status.transformations.machineHidden
            )
        );
      }
      else if (this.activeCategories === 'Hidden') {
        // Filter user submitted jobs
        return this.graph.filter(
          (position) =>
            position.match && (
              position.status && Object.keys(position.status.hiddenBecause).length > 0
            )
        );
      }
      // Get default job list with featured jobs
      let jobs = this.graph
          .filter((position) => position.match);
      if(this.featuredJobs) jobs.unshift(...this.featuredJobs);
      return jobs;
    },
    selectedPositionId() {
      return this.$store.state.selectedPosition
        ? this.$store.state.selectedPosition.id
        : 0;
    },
    computedHeaders() {
      if (this.admin == false) {
        return this.headers.filter((header) => header.value !== 'status');
      }
      return this.headers;
    },
  },
  watch: {
    graph: {
      handler(value) {
        // this.$refs.dataTable.scrollTo(0, 0);
      },
      deep: true,
    },
  },
  methods: {
    openUrl(item) {
      if (window.getSelection().toString().length) return;
      // Send event to analytics service
      AnalyticsService.pushEvent('JobAdOpened', item.title, {
        employer: item.employer.name,
        location: item.location.area,
        city: item.location.city,
        link: item.externalUrl,
      });

      // window.open(item.externalUrl);
      // Capture request and show info dialog
      this.exitDialog = true;
      this.exitUrl = item.externalUrl;
    },
    activateNode(item) {
      if (window.getSelection().toString().length) return;
      this.$store.dispatch('commitSelectedPosition', item);
    },
    refresh() {
      this.$store.dispatch('dispatchGetJobsAdmin');
    },
    saveFavorite(id) {
      this.$store.dispatch('commitFavorite', {
        jobId: id,
        action: this.checkFavorite(id) ? 'remove' : 'add',
      });
    },
    checkFavorite(id) {
      return (
        this.$store.state.userFavorites.findIndex((item) => item.id == id) > -1
      );
    },
  },
};
</script>
<style scoped>
.v-card {
  font-size: 14px;
}
.data-table tr td div {
  font-size: 0.7rem;
}
.position-row {
  opacity: 0.5;
}
.position-logo {
  width: 110px;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
  text-align: center;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  height: 72px;
  background-color: transparent;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding: 1em;
}
.position-title,
.position-subtitle {
  margin: 0;
}
.position-title {
  font-size: 1.1em;
  line-height: 1.2em;
  font-weight: 400;
  margin-top: 0.7em;
}
.position-subtitle {
  font-size: 1em;
  opacity: 0.7;
  margin-bottom: 0;
}
.position-tag-wrapper {
  width: 100%;
}
.position-tag {
  font-size: 0.9em;
  color: rgba(0, 45, 160, 1);
  text-transform: uppercase;
}
.position-open {
  color: rgba(0, 45, 160, 1);
}
.position-tag.cleantech {
  color: #0078a5;
}
.position-tag.tech {
  color: #414548;
}
.position-tag.maritime {
  color: #42899c;
}
.position-tag.health {
  color: #96b98f;
}
.position-tag.experience {
  color: #ab0a7d;
}

.match-row {
  opacity: 1;
}
.reviewed {
  background: rgba(0, 124, 90, 0.15);
}
.featured {
  background: rgb(245, 248, 255);
  border-color: rgba(0, 45, 160, 1);
  border-left-width: 3px;
}
.featured .position-title {
  font-weight: bold;
  color: rgba(0, 45, 160, 1);
}
.featured .position-subtitle{
  color: #000;
}
.list-filter {
  display: none;
}
.active-row {
  background: rgba(0, 45, 160, 0.05);
}
.active-row td:first-child {
  border-left: 4px solid rgba(0, 45, 160, 1);
}
.table-footer-container {
  padding: 1em 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
/deep/ .v-data-table th {
  font-size: 1em;
  font-weight: 300;
  line-height: 0.5em;
  color: var(--v-primary-base);
}
/deep/ .v-data-table span {
  padding-right: 0.3em;
}
/deep/ .v-data-table span span {
  padding-right: 0;
}
/deep/ .v-pagination__item,
/deep/ .v-pagination__navigation {
  box-shadow: none;
}

.v-chip.only-icon {
  padding-right: 6px;
  padding-left: 6px;
}
.dynamic-scroller {
    height: 80vh;
  }

@media screen and (min-width: 960px) {
  .list-wrapper {
    /* height: calc(100vh - 273px); */
  }
  .dynamic-scroller {
    height: 100%;
  }
  .data-table {
    overflow: auto;
    position: relative;
  }
  .data-table tr td div {
    font-size: 0.9rem;
  }
}
</style>
